<template>
    <div class="separator-v"></div>
</template>
<style scoped>
.separator-v {
    border-right-color: var(--clarity-blue);
    border-right-width: 1px;
    border-right-style: solid;
}
</style>
